import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArchive: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconArchive"><Path fillRule="evenodd" clipRule="evenodd" d="M5 2V8H3V21H21.005V8H19V4H12.8107L10.8107 2H5ZM17.5 8V5.5H12.1893L10.1893 3.5H6.5V8H17.5ZM7 12H12.5V13.5H7V12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArchive;
